import DefaultPurchaseFlow from './DefaultPurchaseFlow';
import generateRender from 'shared/utils/generateRender';

const PurchaseFlow = generateRender({
  default: DefaultPurchaseFlow,
});

export default PurchaseFlow;

